import { render, staticRenderFns } from "./BillDialog.vue?vue&type=template&id=676f6836&"
import script from "./BillDialog.vue?vue&type=script&lang=js&"
export * from "./BillDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports